import { createContext, useContext } from 'react';

export interface FormInputsRefContextType {
  [key: string]: React.MutableRefObject<HTMLInputElement | null>;
}

export const FormInputsRefContext =
  createContext<React.MutableRefObject<FormInputsRefContextType> | null>(null);

export const useFormInputsRefContext = () => useContext(FormInputsRefContext);
